const transformFileToBase64 = (file: File) =>
  new Promise((resolve: (vaue: string) => void, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })

export default transformFileToBase64
